import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [subscribeEmail, setSubscribeEmail] = useState(true);
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 3000);
    setFormData({ name: '', email: '', message: '' });
  };

  const handleGetDirections = () => {
    const destination = '3309+W+State+Hwy+29,+Georgetown,+TX+78628';
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          window.open(
            `https://www.google.com/maps/dir/?api=1&origin=${latitude},${longitude}&destination=${destination}&travelmode=driving`,
            '_blank'
          );
        },
        () => {
          // If user denies location, open without origin (Google will prompt)
          window.open(
            `https://www.google.com/maps/dir/?api=1&destination=${destination}`,
            '_blank'
          );
        }
      );
    } else {
      window.open(
        `https://www.google.com/maps/dir/?api=1&destination=${destination}`,
        '_blank'
      );
    }
  };

  return (
    <section id="contact" className="contact">
      <div className="contact__container">
        <div className="contact__info">
          <span className="contact__label">Get In Touch</span>
          <h2 className="contact__heading">
            Contact <span>Us</span>
          </h2>
          <p className="contact__description">
            Whether you're planning a catering event, curious about our menu, 
            or simply want to say hello — we'd love to hear from you. 
            Let's celebrate tradition together!
          </p>
          <div className="contact__details">
            <div className="contact__detail">
              <div className="contact__detail-icon">📍</div>
              <div>
                <h4>Visit Us</h4>
                <p>1005 SE Rock St<br/>Georgetown, TX 78626</p>
              </div>
            </div>
            <div className="contact__detail">
              <div className="contact__detail-icon">📞</div>
              <div>
                <h4>Call Us</h4>
                <p>(214) 636-8990</p>
              </div>
            </div>
            <div className="contact__detail">
              <div className="contact__detail-icon">✉️</div>
              <div>
                <h4>Email Us</h4>
                <p>churrosatx@gmail.com</p>
              </div>
            </div>
            <div className="contact__detail">
              <div className="contact__detail-icon">🕐</div>
              <div>
                <h4>Hours</h4>
                <p>Tue–Sat: 8am – 3pm</p>
              </div>
            </div>
          </div>
          <div className="contact__social">
            <a href="#!" className="contact__social-link" aria-label="Instagram">
              <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
              </svg>
            </a>
            <a href="#!" className="contact__social-link" aria-label="Facebook">
              <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              </svg>
            </a>
            <a href="#!" className="contact__social-link" aria-label="TikTok">
              <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
              </svg>
            </a>
          </div>
        </div>
        
        <div className="contact__form-wrapper">
          <form className="contact__form" onSubmit={handleSubmit}>
            <h3 className="contact__form-title">Drop Us a Line!</h3>
            <div className="contact__field">
              <label htmlFor="name">Name</label>
              <input 
                type="text" 
                id="name" 
                name="name" 
                value={formData.name}
                onChange={handleChange}
                placeholder="Your name"
                required
              />
            </div>
            <div className="contact__field">
              <label htmlFor="email">Email *</label>
              <input 
                type="email" 
                id="email" 
                name="email" 
                value={formData.email}
                onChange={handleChange}
                placeholder="your@email.com"
                required
              />
            </div>
            <div className="contact__field">
              <label htmlFor="message">Message</label>
              <textarea 
                id="message" 
                name="message" 
                rows="5"
                value={formData.message}
                onChange={handleChange}
                placeholder="Tell us what you're looking for..."
                required
              ></textarea>
            </div>
            <div className="contact__subscribe">
              <label className="contact__checkbox">
                <input 
                  type="checkbox" 
                  checked={subscribeEmail}
                  onChange={() => setSubscribeEmail(!subscribeEmail)}
                />
                <span className="contact__checkmark"></span>
                Sign up for our email list for updates, promotions, and more.
              </label>
            </div>
            <button 
              type="submit" 
              className={`contact__submit ${submitted ? 'contact__submit--sent' : ''}`}
            >
              {submitted ? '✓ Message Sent!' : 'Send Message'}
            </button>
            <p className="contact__recaptcha">
              This site is protected by reCAPTCHA and the Google{' '}
              <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>{' '}
              and{' '}
              <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a>{' '}
              apply.
            </p>
          </form>
        </div>
      </div>

      {/* Map Section */}
      <div className="contact__map-section">
        <div className="contact__map-wrapper">
          <div className="contact__map-container">
            <iframe
              title="Churros ATX Location"
              src="https://maps.google.com/maps?q=1005+SE+Rock+St,+Georgetown,+TX+78626&t=&z=15&ie=UTF8&iwloc=&output=embed"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
          <div className="contact__map-cta">
            <div className="contact__map-cta-content">
              <div className="contact__map-cta-icon">🧭</div>
              <h3 className="contact__map-cta-title">Ready for some churros?</h3>
              <p className="contact__map-cta-text">
                Tap below and we'll show you the fastest route to fresh, 
                hand-pressed churros and empanadas.
              </p>
              <button
                onClick={handleGetDirections}
                className="contact__map-btn"
                type="button"
              >
                <span className="contact__map-btn-icon">
                  <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 010-5 2.5 2.5 0 010 5z"/>
                  </svg>
                </span>
                Take Me There!
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
